import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";

export default function PaymentCancel() {
  useSeo({ title: "Checkout cancelled | Insane Circle", description: "Your Insane Circle checkout was cancelled.", path: "/payment/cancel", noindex: true });
  return (
    <section data-testid="payment-cancel-page" className="flex min-h-screen items-center px-5 pt-24 md:px-10">
      <div className="mx-auto max-w-3xl text-center">
        <h1 className="font-display text-5xl font-extrabold uppercase leading-[0.9] tracking-tight sm:text-7xl">Cold feet?</h1>
        <p className="mx-auto mt-6 max-w-md text-base text-haze md:text-lg">Checkout cancelled. No worries, your bag is still saved.</p>
        <Link to="/" data-testid="cancel-back-home" className="mt-10 inline-block rounded-full bg-lime px-8 py-4 font-display text-lg font-extrabold uppercase text-ink transition-transform hover:scale-105">
          Back to the drop
        </Link>
      </div>
    </section>
  );
}
